<template>
  <!-- <span v-if="readonly">{{ data && data.Key ? data.Name : "" }}</span> -->
  <el-cascader
    v-model="data"
    @change="dataChange"
    :clearable="clearable"
    @clear="dataChange"
    style="width: 100%"
    :filterable="true"
    :options="options"
    size="small"
    ref="cascader"
    :disabled="disabled"
    :props="{ value: 'Key', label: 'Name' }"
  >
    <template slot-scope="{ node, data }">
      <div class="subjectList">
        <div v-if="node.isLeaf" class="selItem">
          <span>{{ data.Name }}</span>
        </div>
        <div v-else class="selParent">
          <span>{{ data.Name }}</span>
        </div>
      </div>
    </template>
  </el-cascader>
</template>
<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      default: "",
    },
    clearable: {
      default: true,
    },
    disabled: {
      default: false,
    },
    options: {
      default: [],
    },
  },
  data() {
    return {
      data: "",
    };
  },
  watch: {
    value: {
      handler(v) {
        if (v) this.data = [v.Type.toString(), v.Key];
        else {
          this.data = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    dataChange(v) {
      if (v && v.length == 2) {
        let obj = { Key: v[1], Type: Number(v[0]) };
        this.$emit("change", obj);
      } else {
        this.$emit("change", "");
      }
    },
  },
  mounted() {},
};
</script>
<style>
.el-cascader-node {
  height: 60px !important;
}
</style>
<style lang='scss' scoped>
.subjectList {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .selParent {
    display: flex;
    justify-content: center;
    justify-content: flex-start;
  }
  .selItem {
    display: flex;
    justify-content: center;
    flex-direction: column;
    justify-content: flex-start;

    .desc {
      font-size: 10px;
      line-height: 16px;
      color: silver;
      font-weight: normal;
    }
  }
}
</style>